// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__rCi16","label":"LabeledBox_label__Q1A4t"};